import { ROUTES } from '@/config/routeConfig';
import {
  getCustomerTabSlug,
  CustomerDetailsTab,
} from '@/shared/config/customer-details-tabs';
import { sanitize } from '@/shared/utils/format-utils';

export function getCustomerDetailsPath(
  customerName: string,
  tab?: CustomerDetailsTab | undefined,
): string {
  return ROUTES.CUSTOMER_DETAILS_TAB
    .replace(':customerName', sanitize(customerName))
    .replace(':tabSlug', getCustomerTabSlug(tab));
}

export function getCustomerServiceLineDetailsPath(
  customerName: string,
  serviceLineNumber: string,
): string {
  return ROUTES.CUSTOMER_SERVICE_LINE_DETAILS
    .replace(':customerName', sanitize(customerName))
    .replace(':serviceLineNumber', serviceLineNumber);
}
